import React from 'react';
import PropTypes from 'prop-types';
import {
	Icon,
	Popup
} from 'semantic-ui-react';

import styles from './form.module.css';

const DescriptionTooltip = ( { text } ) => {
	return (
		<Popup
			position="top center"
			trigger={
				<Icon
					name="info circle"
				/>
			}
			wide="very"
		>
			<Popup.Content>
				<div
					dangerouslySetInnerHTML={ { __html: text } }
					className={ styles.instructions }
				/>
			</Popup.Content>
		</Popup>
	);
};

DescriptionTooltip.propTypes = { text: PropTypes.string.isRequired };

export default DescriptionTooltip;
